module.exports = {"id":"149791","name":"Wes Hoolahan","rating":"75","photo":"./data/images/photos/0/149791.png","club":{"name":"Norwich City","logo":"./data/images/clubs/NorwichCity.png"},"positions":["MOC","MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WesHoolahan0.json
// module id = 4330
// module chunks = 0